export default {"src":"/_next/static/media/property_records_2.1ab1280c.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};